const STATUSES = new Set([
  'loading',
  'empty',
  'information',
  'success',
  'warning',
  'error',
  'validation',
  'destructive',
]);

const ASSERTIVE_STATUSES = new Set([
  'error',
  'validation',
  'destructive',
]);

export default function ApplicationStateRegion({
  status = 'information',
  density = 'ordinary',
  message,
  detail,
  role,
  live,
  className = '',
}) {
  if (!STATUSES.has(status)) {
    throw new Error(`Unsupported ApplicationStateRegion status: ${status}`);
  }

  if (!['ordinary', 'compact'].includes(density)) {
    throw new Error(
      `Unsupported ApplicationStateRegion density: ${density}`
    );
  }

  const assertive = ASSERTIVE_STATUSES.has(status);
  const resolvedRole = role || (assertive ? 'alert' : 'status');
  const resolvedLive = live || (assertive ? 'assertive' : 'polite');
  const classes = [
    'av-app-state-region',
    `av-app-state-region--${status}`,
    density === 'compact' ? 'av-app-state-region--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      aria-live={resolvedLive}
      className={classes}
      role={resolvedRole}
    >
      <p className="av-app-state-region__message">
        {message}
      </p>
      {detail && (
        <p className="av-app-state-region__detail">
          {detail}
        </p>
      )}
    </div>
  );
}
